import { render } from "./orderComplete.vue?vue&type=template&id=744b4f02"
import script from "./orderComplete.vue?vue&type=script&lang=js"
export * from "./orderComplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__